// Copyright (c) 2016 Deere & Company

import './checkbox-with-search.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import CheckboxWithSearchFilterBody from './checkbox-with-search-filter-body';
import {translate} from '../../../services/translation-service';

const CheckboxWithSearchFilterControlled = props => {

    const accordionBody = (
        <CheckboxWithSearchFilterBody
            initialState={props.initialState}
            list={props.list}
            minNumberOfItems={props.minNumberOfItems}
            onCheckboxListChange={props.onCheckboxListChange}
            onInputChange={props.onInputChange}
            onToggleAll={props.onToggleAll}
            searchInput={props.searchInput}
            searchPlaceholder={props.searchPlaceholder}
            valueKey={props.valueKey}
        />
    );

    return (
        <Accordion
            accordionId='checkbox-filter-accordion'
            body={accordionBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={translate(props.title)}
        />
    );

};

CheckboxWithSearchFilterControlled.displayName = 'CheckboxWithSearchFilterControlled';

CheckboxWithSearchFilterControlled.propTypes = {
    initialState: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    list: PropTypes.array.isRequired,
    minNumberOfItems: PropTypes.number.isRequired,
    onCheckboxListChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired,
    searchInput: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    valueKey: PropTypes.string.isRequired
};

export default CheckboxWithSearchFilterControlled;



// WEBPACK FOOTER //
// ./src/shared/components/facets/checkbox-with-search-filter/controlled.js